import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import slugify from "slugify";
import { ReactSVG } from 'react-svg';
import Collapsible from "react-collapsible";

const FaqSection = ({
    data
}) => {
    const {
        title,
        copy,
        image = false,
        disclaimer = false,
        video = false,
        button_text,
        button_link,
        image_before_button = false,
        accordion,
        use_accordion
    } = data
    const sectionSlug = slugify(title, { lower: true })
    
    const [currentOpened, setCurrentOpened] = useState(null);
    const handleClick = (index) => {
        setCurrentOpened(currentOpened === index ? null : index);
    };

    return (
        <div className={`faq-section button-last-${image_before_button}`} id={sectionSlug}>
            <h2>{title}</h2>
            <div className='description'
                dangerouslySetInnerHTML={{
                    __html: copy,
                }}
            />
            {disclaimer && <div className='disclaimer' >
                <ReactSVG src="/icons/support-disclaimer.svg" className='icon' />
                <span>{disclaimer}</span>
            </div>}
            {(use_accordion && accordion.length) && <div className='accordions' >
                {accordion.map((accordionItem, index) => (
                    <Collapsible
                        handleTriggerClick={handleClick}
                        accordionPosition={index}
                        openedClassName="active"
                        open={index === currentOpened}
                        trigger={accordionItem.title}

                        easing="cubic-bezier(.67,.86,.68,1.19)"
                        transitionTime={400}
                    >
                        {accordionItem.items.map((item) => (
                            <div className='accordion-content'>
                                <div className='subtitle'>{item.subtitle}</div>
                                <div className='text' dangerouslySetInnerHTML={{
                                    __html: item.text,
                                }}/>
                            </div>
                        ))}
                    </Collapsible>
                ))}
            </div>}
            {button_text &&
                <Link href={button_link}>
                    <a className="btn btn-secondary">{button_text}</a>
                </Link>
            }
            {(!video && image) && <img src={image} alt={title} width="789px" height="444px" />}
            {video && <video
                playsInline
                video="true"
                controls
                poster={image ? image : ""}
            >
                <source
                    src={video.url}
                    type="video/mp4"
                />
            </video>}
        </div>
    );
};

export default FaqSection;